var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.file)?_c('v-btn',{attrs:{"color":"primary","icon":""},on:{"click":_vm.download}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v(_vm._s(_vm.$t("icons.download")))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }